<template>
    <v-container fill-height fluid grid-list-xl>
      <v-layout wrap>
        <v-flex md12>
          <ReceiptViewer
            v-if="showDialog"
            :showDialog="showDialog"
            v-on:hide="receiptViewerOnHide()"
            v-on:getAllReceipts="getReceipts"
            v-on:closeAutoPilot="closeAutoPilot"
            :receiptImage="receiptImageElement"
            :receiptImageIsLoading="receiptImageIsLoading"
          />
          <v-row class="mb-6" style="padding: 0 12px;">
            <v-col cols="12" md="12">
              <v-card>
                <v-flex>
                  <div class="autopilot-button-container">
                    <v-btn
                      color="primary"
                      @click="openAutoPilot"
                      :loading="autoPilotMode"
                      :disabled="autoPilotMode"
                    >
                      Click Here To See A Receipt
                      <template v-slot:loader>
                        <span>Waiting for receipts ({{remainingTime}})</span>
                      </template>
                    </v-btn>
                    <countdown
                      v-if="autoPilotMode && !showDialog"
                      :time="countDown"
                      :interval="1000"
                      @end="handleCountdownEnd"
                      @progress="handleCountdownProgress"
                    >
                      <v-progress-linear :value="progress" color="blue accent-4"></v-progress-linear>
                    </countdown>
                  </div>
                  <v-switch v-model="autoPilotMode" label="Autopilot" @click.native="turnCountDownBackToDefault" ></v-switch>
                </v-flex>
              </v-card>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  
  <script>
  import { mapActions, mapGetters, mapMutations } from "vuex";
  import { mapFields } from "../store/helpers";
  
  import ReceiptViewer from "../components/ReceiptViewer";
  
  import moment from "moment";
  
  export default {
    components: {
      // ReceiptModal
      ReceiptViewer
    },
    data: function() {
      return {
        img: new Image(),
        receiptImageElement: new Image(),
        receiptImageIsLoading: true,
        countDown: 4000, // DEFAULT COUNTDOWN TIME
        dialogErrShow: false,
        secondsLeft: 0,
        error: "",
        showDialog: false,
        receipts: [],
        pendingReceiptInQuee: 0,
        pendingReceiptsOnHold: 0,
        performance: [],
        performanceType: "Monthly Table",
        progress: 0,
        search: "",
        isLoading: false,
        fullPage: true,
        counting: false,
        autoPilotIntervalDefault: 4000,
        autoRefreshReceipts: true,
        receiptInterval: 0,
        headerBgVariant: "dark",
        options: {
          format: "DD/MM/YYYY HH:mm",
          useCurrent: true
        },
        headers: [
          {
            sortable: false,
            text: "Uploaded at",
            value: "uploadedAt"
          },
          {
            sortable: true,
            text: "Receipt ID",
            value: "id"
          },
          {
            sortable: false,
            text: "Campaign",
            value: "campaignTitle"
          }
        ],
        receiptReferenceNumber:""
      };
    },
    watch: {
      showDialog(val) {
  
        if (val === false) {
          this.img = new Image();
          this.receiptImageElement = new Image();
          this.receiptImageIsLoading = true;
          
          if (this.autoPilotMode) {
            setTimeout(() => {
              this.autoPilot();
            }, 1000);
          }
        }
      },
      autoPilotMode(val) {
        this.counting = val;
      },
      performanceType() {
        this.updatePerformance();
      },
      autoRefreshReceipts(val) {
        localStorage.autoRefreshReceipts = val;
      }
    },
    computed: {
      ...mapGetters([
        "userToken",
        "allReceipts",
        "selectedDashboard",
        "userRoles",
        "isTester"
      ]),
      ...mapFields([
        "reClaimed",
        "reClaimText",
        "referenceNumber",
        "receiptImageURL",
        "createdAt",
        "createdAtDate",
        "createdAtTime",
        "status",
        "id",
        "campaignTitle",
        "campaign_fk",
        "receiptNumber",
        "total",
        "campaignRetailers",
        "hasWallet",
        "products",
        "couponsToCreate",
        "hasEditableCoupons",
        "productImageURL",
        "coinImageURL",
        "detailsText",
        "campaignEndDate",
        "campaignStartDate",
        "processedProducts",
        "productTotal",
        "retailerFk",
        "customerToken",
        "selectedProducts",
        "receiptDateTime",
        "orderId",
        "sendSftp",
        "receiptId",
        "vatNumber",
        "fraud",
        "selectedCheckbox",
        "country",
        "postCode",
        "ciuNumber",
        "retailerName",
        "retailerAddresss",
        "retailerCity",
        "allRetailerNames",
        "allRetailerAddresses",
        "allCiuNumbers",
        "extra",
        "clubCode",
        "fiscalId",
        "rppData"
      ]),
      autoPilotMode: {
        get() {
          return this.$store.getters.autoPilotMode;
        },
        set(val) {
          this.setAutoPilotMode(val);
        }
      },
      remainingTime() {
        return ((this.countDown / 1000) * this.progress) / 100;
      },
      receiptListLoading() {
        return this.autoRefreshReceipts && this.receipts.length === 0;
      },
      hasPendingReceipt: {
        get() {
          return this.selectedDashboard.hasPendingReceipt;
        }
      },
      hasOnHoldReceipts: {
        get() {
          return this.selectedDashboard.hasOnHoldReceipts;
        }
      },
    },
    mounted() {
      if ("name" in this.selectedDashboard === false) {
        const dashboard = JSON.parse(localStorage.selectedDashboard);
        this.$store.commit("setDashboard", dashboard);
      }
      this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
      const payload = {
        userToken: this.userToken,
        dashboard: this.selectedDashboard
      };
      // this.getReceipts(payload);
      // this.updatePerformance();
      // if (localStorage.autoRefreshReceipts)
      //   this.autoRefreshReceipts =
      //     localStorage.autoRefreshReceipts === "true" ? true : false;
      // this.$eventHub.$on("updateList", () => {
      //   this.getReceipts();
      //   if (this.autoPilotMode) {
      //     this.autoPilot();
      //   }
      // });
    },
    destroyed() {
      clearInterval(this.receiptInterval);
    },
    methods: {
      ...mapMutations(["setAutoPilotMode"]),
      ...mapActions([
        "getFraudReceipts",
        "dropReceipt",
        "setReceiptModalState",
        "getReceiptWithId",
        "getProductsList",
        "getReceiptwithRefNumber",
        "getLocationsList",
        "getDashboardData",
      ]),
      updatePerformance() {
        this.getPerformance({
          userToken: this.userToken,
          dashboard: this.selectedDashboard
        }).then(res => {
          this.pendingReceiptInQuee = res.pendingReceipts || 0;
          this.pendingReceiptsOnHold = res.onHoldReceipts || 0;
          this.performance = [];
          let performanceData = res.monthlyPerformance;
  
          if (this.performanceType === "Daily Graph") {
            performanceData = res.dailyPerformance;
            performanceData.forEach(perf => {
              this.performance.push([perf.day, perf.count]);
            });
            return;
          }
  
          if (performanceData)
            performanceData.forEach(perf => {
              this.performance.push([perf.month, perf.count]);
            });
        });
      },
      customSort(items, index, isDesc) {
        if (index[0] === "receiptId") {
          if (!isDesc) items.sort((a, b) => (a.id < b.id ? 1 : -1));
          else items.sort((a, b) => (a.id < b.id ? 1 : -1));
        }
        return items;
      },
      getReceipts() {
        // return new Promise((resolve, reject) => {
        //   this.getAllReceipts({
        //     userToken: this.userToken,
        //     dashboard: this.selectedDashboard
        //   })
        //     .then(res => {
        //       this.receipts = [...res.receipts];
        //       resolve(true);
        //     })
        //     .catch(e => {
        //       console.log("GET RECEIPTS ERROR:: ", e);
        //       reject();
        //     });
        // });
        return true
      },
      formatDate(date) {
        return moment(date).format("DD/MM/YYYY HH:mm");
      },
      circularProgress() {
        return Math.floor((100 * this.secondsLeft) / (this.countDown / 1000));
      },
      handleCountdownProgress(data) {
        this.secondsLeft = data.totalSeconds;
        this.progress = Math.floor(
          (100 * this.secondsLeft) / (this.countDown / 1000)
        );
      },
      openAutoPilot() {
        this.counting = true;
        this.setAutoPilotMode(true)
        this.autoPilot();
      },
      autoPilot() {
        this.counting = true;
        let receipt = null;
        this.setAutoPilotMode(true)
        // this.getReceipts().then(() => {
        const payload = {
          userToken: this.userToken,
          dashboard: this.selectedDashboard
        };
        this.getFraudReceipts(payload).then(async (res) => {
          console.log("ONE RECEIPT::", res);
          if (res.response) {
            this.setAutoPilotMode(true)
            this.counting = false;
            // there is a receipt in the qeue
            receipt = res.receipt;
            const products = res.campaignProducts;
            const payload = {
              userToken: this.userToken,
              dashboard: this.selectedDashboard,
              campaign_fk: receipt.campaign_fk
            };
            try {
              await this.getDashboardData(payload);
            } catch (e) {
              console.log("GET DASHBOARD DATA ERROR:: ", e);
              return
            }
            if (this.selectedDashboard.isCroppable) {
              this.receiptImageURL = receipt.receiptFullImageURL;
            } else {
              this.receiptImageURL = receipt.receiptImageURL;
            }
            this.productImageURL = receipt.productImageURL;
            this.coinImageURL = receipt.coinImageURL;
            this.img = new Image();
            this.receiptImageIsLoading = true;
            this.img.onload = () => {
              this.receiptImageIsLoading = false;
              this.receiptImageElement = this.img;
            };

            this.img.src = `${this.receiptImageURL}?${new Date().getTime()}`;
            this.receiptDateTime = receipt.receiptDateTime;
            this.extra = receipt.extra ? JSON.parse(receipt.extra) : {};
            this.createdAt = receipt.createdAt;
            this.campaignTitle = receipt.campaignTitle;
            this.campaign_fk = receipt.campaign_fk;
            this.fraud = receipt.fraud
            this.country = receipt.country;
            this.selectedCheckbox = (receipt.extra && JSON.parse(receipt.extra).selectedCheckbox) ? JSON.parse(receipt.extra).selectedCheckbox : { "vatMetro": { value: false, status: 0 }, "rossmannDiscount": { value: false, status: 0 } }
            this.vatNumber = receipt.extra && JSON.parse(receipt.extra).vatNumber ? JSON.parse(receipt.extra).vatNumber : ''
            if (receipt.clubCode) this.clubCode = receipt.clubCode;
            if (receipt.fiscalId) this.fiscalId = receipt.fiscalId;
            if (receipt.rppData) this.rppData = receipt.rppData;
            if (this.selectedDashboard.extraRetailerField && receipt.location) {
              try {
                const { cif_number, retailer_name, retailer_address, retailer_city } = JSON.parse(receipt.location);
                this.ciuNumber = cif_number;
                this.retailerName = retailer_name;
                this.retailerAddresss = retailer_address;
                this.retailerCity = retailer_city;
              } catch (e) {
                console.log("EXTRA RETAILER FIELD ERROR:: ", e)
              }
            }

            if (receipt.selectedProducts) {
              console.log(
                "SETTING SELECTED PRODUCTS",
                receipt.selectedProducts
              );
              this.selectedProducts = JSON.parse(receipt.selectedProducts);
            }

            const isValidDate = moment(
              receipt.receiptDateTime,
              "YYYY-MM-DD"
            ).isValid();
            if (isValidDate) {
              this.createdAtDate = moment
                .utc(receipt.receiptDateTime)
                .format("YYYY-MM-DD");
            } else {
              this.createdAtDate = "";
            }
            this.createdAtTime = receipt.receiptDateTime;
            this.status = receipt.status;
            this.orderId = receipt.orderId;
            this.sendSftp = receipt.sendSftp;
            this.id = receipt.receiptToken;
            this.reClaimed = receipt.reClaimed;
            this.reClaimText = receipt.reClaimText;
            this.customerToken = receipt.customerToken;
            this.referenceNumber = receipt.referenceNumber;
            this.receiptNumber = receipt.identifiedId;
            this.total = receipt.total;
            this.postCode = receipt.postCode;
            this.couponsToCreate = receipt.couponsPerReceipt;
            this.detailsText = receipt.detailsText;
            this.retailerFk = receipt.retailer;
            this.receiptId = receipt.receiptId
            if(typeof this.retailerFk === 'string'){
              this.retailerFk = parseInt(this.retailerFk)
            }
            this.productImageURL = receipt.productImageURL;
            this.coinImageURL = receipt.coinImageURL;


            this.campaignEndDate = moment(receipt.campaignEndDate).format(
              "DD-MM-YYYY"
            );
            this.campaignStartDate = moment(receipt.campaignStartDate).format(
              "DD-MM-YYYY"
            );
            this.hasWallet = receipt.hasWallet;
            if (this.hasWallet) {
              const identifications = JSON.parse(receipt.identifications);

              if (identifications)
                this.productTotal = identifications.productTotal;
            }
            this.getProductsList({
              dashboard: this.selectedDashboard,
              campaignId: receipt.campaign_fk
            }).then(products => {
              console.log("PRODUCTS FROM DB::", products);
              if (products.length) {
                this.products = products;
                this.processedProducts = [];
                this.showDialog = true;
              } else if (this.selectedDashboard.campaignId === 'pg-ro') {
                this.products = products
                this.processedProducts = []
                this.showDialog = true
              }
            });
            if (this.selectedDashboard.extraRetailerField)
              this.getLocationsList({
                  dashboard: this.selectedDashboard,
                  campaignId: receipt.campaign_fk
                }).then(locations => {
                  this.allRetailerNames = locations.retailerNames,
                  this.allRetailerAddresses = locations.retailerAddresses,
                  this.allCiuNumbers = locations.cifNumbers
                })

            if (this.couponsToCreate === -1) {
              this.hasEditableCoupons = true;
              this.couponsToCreate = 1;
            }
            this.campaignRetailers = res.campaignRetailers;

            if (receipt.hasWallet) {
              this.hasWallet = receipt.hasWallet;
            }
            if (products && products.length > 0) {
              this.products = products;
            }
          } else {
            if (this.autoPilotMode) {
              setTimeout(() => {
                this.autoPilot();
              }, 3000);
            }
          }
        }).catch((error) => {
          console.log("AUTOPILOT ERROR::", error);
          if (this.autoPilotMode) {
            setTimeout(() => {
              this.autoPilot();
            }, 5000);
          }
        });
        // });
      },
      closeAutoPilot() {
        this.counting = false;
        this.setAutoPilotMode(false)
      },
      setReceipt(res) {
        const { receipt } = res;
        if (receipt.selectedProducts) {
          this.selectedProducts = JSON.parse(receipt.selectedProducts);
        }

        this.receiptImageURL =
          receipt.rawImageUrl.indexOf("http") != -1
            ? receipt.rawImageUrl
            : `https://api.cekkazanapp.com${receipt.rawImageUrl}`;

        this.img = new Image();
        this.receiptImageIsLoading = true;
        this.img.onload = () => {
          this.receiptImageIsLoading = false;
          this.receiptImageElement = this.img;
        };

        this.img.src = `${this.receiptImageURL}?${new Date().getTime()}`;
        this.createdAt = receipt.createdAt;
        this.receiptDateTime = receipt.receiptDateTime;
        this.campaignTitle = receipt.campaignTitle;
        this.campaign_fk = receipt.campaign_fk;
        this.fraud = receipt.fraud
        this.selectedCheckbox = (receipt.extra && JSON.parse(receipt.extra).selectedCheckbox) ? JSON.parse(receipt.extra).selectedCheckbox : { "vatMetro": { value: false, status: 0 }, "rossmannDiscount": { value: false, status: 0 } }
        this.vatNumber = receipt.extra && JSON.parse(receipt.extra).vatNumber ? JSON.parse(receipt.extra).vatNumber : ''
        if (this.selectedDashboard.extraRetailerField && receipt.location) {
          try {
            const { cif_number, retailer_name, retailer_address, retailer_city } = JSON.parse(receipt.location);
            this.ciuNumber = cif_number;
            this.retailerName = retailer_name;
            this.retailerAddresss = retailer_address;
            this.retailerCity = retailer_city;
          } catch (e) {
            console.log("EXTRA RETAILER FIELD ERROR:: ", e)
          }
        }
        const isValidDate = moment(
          receipt.receiptDateTime,
          "YYYY-MM-DD"
        ).isValid();
        if (isValidDate) {
          this.createdAtDate = moment
            .utc(receipt.receiptDateTime)
            .format("YYYY-MM-DD");
        } else {
          this.createdAtDate = "";
        }
        this.createdAtTime = receipt.receiptDateTime;
        this.status = receipt.status;
        this.orderId = receipt.orderId;
        this.sendSftp = receipt.sendSftp;
        this.id = receipt.receiptToken;
        this.reClaimed = receipt.reClaimed;
        this.reClaimText = receipt.reClaimText;

        this.customerToken = receipt.customerToken;
        this.receiptNumber = receipt.identifiedId;
        this.referenceNumber = receipt.referenceNumber;
        this.total = receipt.total;
        this.postCode = receipt.postCode;
        this.couponsToCreate = receipt.couponsPerReceipt;
        this.campaignRetailers = res.campaignRetailers;
        if (this.couponsToCreate === -1) {
          this.hasEditableCoupons = true;
          this.couponsToCreate = 1;
        }

        this.hasWallet = receipt.hasWallet;

        if (this.hasWallet) {
          if (receipt.identifications) {
            const identifications = JSON.parse(receipt.identifications);
            this.productTotal = identifications.productTotal;
          }
        }
        if (res.campaignProducts.length) {
          this.products = res.campaignProducts;
          this.processedProducts = [];
          if (
            "processedProducts" in receipt &&
            receipt.processedProducts != null
          ) {
            const parsedSelecteds = JSON.parse(receipt.processedProducts);
            parsedSelecteds.forEach(selectedProduct => {
              const product = {
                groupingId: selectedProduct.groupingId.split("$$")[1],
                items: selectedProduct.items,
                total: selectedProduct.total
              };
              this.processedProducts.push(product);
              const foundProduct = this.products.find(
                e => e.ean === product.groupingId
              );
              foundProduct.count = product.items;
            });
          }
        }

        this.detailsText = receipt.detailsText;
        this.campaignEndDate = moment(receipt.campaignEndDate).format(
          "DD-MM-YYYY"
        );
        this.campaignStartDate = moment(receipt.campaignStartDate).format(
          "DD-MM-YYYY"
        );
      },
      handleCountdownEnd() {
        this.counting = false;
        this.autoPilot({ withRing: true });
      },
      searchReferenceNumber() {
        this.getReceiptwithRefNumber({
          userToken: this.userToken,
          referenceNumber: this.receiptReferenceNumber,
          dashboard: this.selectedDashboard
        }).then(async (res) => {
          const receipt = res.receipt;
          const products = res.campaignProducts;
          if (this.selectedDashboard.isCroppable) {
            this.receiptImageURL = receipt.receiptFullImageURL;
          } else {
            this.receiptImageURL = receipt.receiptImageURL;
          }
          this.productImageURL = receipt.productImageURL;
          this.coinImageURL = receipt.coinImageURL;

          const payload = {
            userToken: this.userToken,
            dashboard: this.selectedDashboard,
            campaign_fk: receipt.campaign_fk
          };

          try {
            await this.getDashboardData(payload);
          } catch (e) {
            console.log("GET DASHBOARD DATA ERROR:: ", e);
            return
          }
          this.img = new Image();
          this.receiptImageIsLoading = true;
          this.paymentAmount = receipt.paymentAmount;
          this.img.onload = () => {
            this.receiptImageIsLoading = false;
            this.receiptImageElement = this.img;
          };

          this.country = receipt.country;
          this.img.src = `${this.receiptImageURL}?${new Date().getTime()}`;
          this.createdAt = receipt.createdAt;
          this.campaignTitle = receipt.campaignTitle;
          this.campaign_fk = receipt.campaign_fk;
          this.fraud = receipt.fraud
          this.receiptDateTime = receipt.receiptDateTime;
          this.extra = receipt.extra ? JSON.parse(receipt.extra) : {};
          this.createdAtTime = moment(receipt.updatedAt).format("HH:MM");
          this.createdAtDate = receipt.updatedAt;
          this.status = receipt.status;
          this.id = receipt.receiptToken;
          this.customerToken = receipt.customerToken;
          this.referenceNumber = receipt.referenceNumber;
          this.receiptNumber = receipt.identifiedId;
          this.total = receipt.total;
          this.postCode = receipt.postCode;
          this.couponsToCreate = receipt.couponsPerReceipt;
          this.detailsText = receipt.detailsText;
          this.receiptId = receipt.receiptId
          this.retailerFk =
            receipt.retailer == "15" ? "Not selected" : receipt.retailer;
          if (typeof this.retailerFk === "string") {
            this.retailerFk = parseInt(this.retailerFk);
          }
          if (this.selectedDashboard.extraRetailerField && receipt.location) {
            try {
              const { cif_number, retailer_name, retailer_address, retailer_city } = JSON.parse(receipt.location);
              this.ciuNumber = cif_number;
              this.retailerName = retailer_name;
              this.retailerAddresss = retailer_address;
              this.retailerCity = retailer_city;
            } catch (e) {
              console.log("EXTRA RETAILER FIELD ERROR:: ", e)
            }
          }
          this.campaign_fk = receipt.campaignId;
          this.fraud = receipt.fraud
          this.rejectReason = receipt.rejectReason;
          this.paymentAmount = receipt.paymentAmount;
          if (receipt.clubCode) this.clubCode = receipt.clubCode;
          if (receipt.fiscalId) this.fiscalId = receipt.fiscalId;
          if (receipt.rppData) this.rppData = receipt.rppData;
          this.selectedCheckbox = (receipt.extra && JSON.parse(receipt.extra).selectedCheckbox) ? JSON.parse(receipt.extra).selectedCheckbox : { "vatMetro": { value: false, status: 0 }, "rossmannDiscount": { value: false, status: 0 } }
          this.vatNumber = receipt.extra && JSON.parse(receipt.extra).vatNumber ? JSON.parse(receipt.extra).vatNumber : ''
          this.campaignEndDate = moment(receipt.campaignEndDate).format(
            "DD-MM-YYYY"
          );
          this.campaignStartDate = moment(receipt.campaignStartDate).format(
            "DD-MM-YYYY"
          );
          this.hasWallet = receipt.hasWallet;
          if (receipt.selectedProducts) {
            this.selectedProducts = JSON.parse(receipt.selectedProducts);
          }
          if (this.hasWallet) {
            const identifications = JSON.parse(receipt.identifications);

            if (identifications) this.productTotal = identifications.productTotal;
          }

          this.getProductsList({
            dashboard: this.selectedDashboard,
            campaignId: receipt.campaignId
          }).then(products => {
            if (products.length) {
              this.products = products;
              this.processedProducts = [];
              this.showDialog = true;
            } else if (this.selectedDashboard.campaignId === 'pg-ro') {
              this.products = products
              this.processedProducts = []
              this.showDialog = true
            }
          });
          if (this.selectedDashboard.extraRetailerField)
            this.getLocationsList({
              dashboard: this.selectedDashboard,
              campaignId: receipt.campaign_fk
            }).then(locations => {
              this.allRetailerNames = locations.retailerNames,
              this.allRetailerAddresses = locations.retailerAddresses,
              this.allCiuNumbers = locations.cifNumbers
            })

          if (this.couponsToCreate === -1) {
            this.hasEditableCoupons = true;
            this.couponsToCreate = 1;
          }
          this.campaignRetailers = res.campaignRetailers;

          if (receipt.hasWallet) {
            this.hasWallet = receipt.hasWallet;
          }
          if (res.campaignProducts) {
            this.products = res.campaignProducts;
            this.processedProducts = [];
            if (
              "processedProducts" in receipt &&
              receipt.processedProducts != null
            ) {
              const parsedSelecteds = JSON.parse(receipt.processedProducts);
              parsedSelecteds.forEach(selectedProduct => {
                const product = {
                  groupingId: selectedProduct.groupingId.split("$$")[1],
                  items: selectedProduct.items,
                  total: selectedProduct.total
                };
                this.processedProducts.push(product);
                const foundProduct = this.products.find(
                  e => e.ean === product.groupingId
                );
                foundProduct.count = product.items;
              });
            }
          }
        });
      },
      receiptViewerOnHide() {
        this.showDialog = false;
      },

      turnCountDownBackToDefault() {
        this.countDown = this.autoPilotIntervalDefault;
      }
    }

  };
  </script>
  
  <style>
  .performance-selector {
    padding: 6px 12px !important;
  }
  .performance-selector .v-input {
    margin-left: auto;
    width: auto;
    max-width: 150px;
  }
  .autopilot-button-container .v-btn {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    width: 100%;
  }
  .autopilot-button-container .v-progress-linear {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .performance-table {
    max-height: 400px;
    overflow: auto;
  }
  .custom-refresh-switch {
    display: flex;
    margin-left: 12px;
  }
  .custom-refresh-switch .v-input__slot {
    margin-bottom: 0;
  }
  .custom-refresh-switch .v-messages {
    display: none;
  }
  .v-progress-linear__indeterminate.short.true {
    background-color: #2196f3 !important;
    border-color: #2196f3 !important;
  }
  </style>
  